import React, { useContext } from 'react';

import { ModalContext } from './modal-provider';

export interface IModalTriggerProps {
    children: React.ReactNode;
}

export const ModalTrigger = (props: IModalTriggerProps): React.JSX.Element => {
    const { open, id } = useContext(ModalContext);

    const enhanceItem = (child: React.ReactNode) => {
        if (!React.isValidElement(child)) {
            return child;
        } else if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onClick: (event: React.MouseEvent<HTMLElement>) => {
                    event.preventDefault();

                    if (open) {
                        open();
                    }
                },
                url: `#${id || ''}`,
            } as React.HTMLAttributes<HTMLElement>);
        }
    };

    const children = React.Children.map(props.children, enhanceItem.bind(this));
    const child = children && children.length ? children[0] : null;

    return child ? <>{React.Children.only(child)}</> : <React.Fragment />;
};
